import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/app.vue?vue&type=script&lang=js&
// module id = 193
// module chunks = 2